// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.main-container[data-v-69b3c6a7] {\n    margin: .5em !important;\n}\n", ""]);
// Exports
module.exports = exports;
